package one.healthium.profile.navigation.healthKit

import com.arkivanov.decompose.ComponentContext

class DefaultHealthKitSettingsComponent(
    componentContext: ComponentContext,
    private val onBackClicked: () -> Unit,
) : HealthKitSettingsComponent, ComponentContext by componentContext {
    override fun onBackClicked() {
        onBackClicked.invoke()
    }
}
